<script setup lang="ts">
  definePageMeta({
    layout: 'blank',
    middleware: ['shopify-extension']
  })

  useFontsCssCompanySet()

  // http://xxxx/play/shopify/section-referral?langcode=fr&customer_id=1234&currencycode=DKK&currencyrate=7.606803&shop=test.myshopify.com
  const { companyId } = storeToRefs(useStoreApp())
  useStoreBranding().fetchBrandings(companyId.value)
  const { brandings } = storeToRefs(useStoreBranding())
  const { data: referralProgram } = useStoreReferral().getReferralProgram(companyId.value)
  const { company } = storeToRefs(useStoreCompany())

  onMounted(() => {
    observer.value = new ResizeObserver(postNewHeightMessage)
    observer.value.observe(document.body)
  })

  onBeforeMount(() => {
    useAppLocale().applyLocale()
  })

  const observer = ref<ResizeObserver | null>(null)

  onUnmounted(() => {
    observer.value?.disconnect()
  })

  const postNewHeightMessage = () => {
    const { body, documentElement } = document
    const height = Math.max(body.scrollHeight, body.offsetHeight, documentElement.offsetHeight)
    window.parent.postMessage({ height, isWeWiink: true, isAccount: true }, '*')
  }
</script>

<template>
  <SectionReferralCard
    v-if="brandings && referralProgram && referralProgram.enable && company?.settings.features.referral"
    :referral-program="referralProgram"
    :is-extension-mode="true"
    class="section-referral"
  />
</template>
